"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref != null) {
        ref.current = value;
    }
    return ref;
}
exports.assignRef = assignRef;



//////////////////
// WEBPACK FOOTER
// ./~/use-callback-ref/dist/es5/assignRef.js
// module id = 189
// module chunks = 0